import { render, staticRenderFns } from "./DedicatedFundListDedicatedFundPlanCard.vue?vue&type=template&id=a4cacdb6"
import script from "./DedicatedFundListDedicatedFundPlanCard.vue?vue&type=script&lang=js"
export * from "./DedicatedFundListDedicatedFundPlanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports